import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import GetHeartbeats from './Admin/GetHeartbeats';
import GetLotsWithMostRevisions from './Admin/GetLotsWithMostRevisions';
import GetLotsWithMostImports from './Admin/GetLotsWithMostImports';
import SiteAlerts from './Admin/SiteAlerts';
import GetQirs from './Admin/GetQir';
import GetSample from './Admin/GetSample';
import SampleManagerApiHealthCheck from './Admin/SampleManagerApiHealthCheck';
import SendFileToNifi from './Admin/SendFileToNiFi';
import CreateEmail from './Admin/CreateEmail';
import CloneConfiguration from './Admin/CloneConfiguration'
import GetRecentlyReceivedRecipes from './Admin/GetRecentllyReceivedRecipes';
import GetRecentlyUpdatedRecipes from './Admin/GetRecentlyUpdatedRecipes';

const Admin = () => {
    const tiles = [
        <GetHeartbeats />,
        <GetRecentlyReceivedRecipes />,
        <GetRecentlyUpdatedRecipes />,
        <GetLotsWithMostRevisions />,
        <GetLotsWithMostImports />,
        <GetSample />,
        <GetQirs />,
        <SampleManagerApiHealthCheck />,
        <SiteAlerts />,
        <SendFileToNifi />,
        <CreateEmail />,
        <CloneConfiguration />,
    ]

    return (
        <Container>
            <Row xs={1} md={2} lg={3} xl={4}>
                {tiles.map((card, index) =>
                    <Col className="pt-2" key={`tile-${index}`}>
                        {card}
                    </Col>
                )}
            </Row>
        </Container>
    );
}

export default Admin